
export class IPAddressRangeModel {
  begin: string;
  end: string;
  range: string;
}
